module.exports = __webpack_public_path__ + "static/media/reception-custom-sample.d2ddb587.png";